import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import SiteSurveyResponseForm from '../../../components/forms/SiteSurveyResponseForm';
import { useCreateSiteSurveyResponse } from '../../../hooks/useSiteSurveyResponseApi';
import { useNavigate } from 'react-router-dom';
import { SiteSurveyResponseDTO } from '../../../services/apiClient';

const SiteSurveyResponseCreate: React.FC = () => {
  const createSiteSurveyResponse = useCreateSiteSurveyResponse();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Site Survey Responses', href: '/admin/sitesurveyresponses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: SiteSurveyResponseDTO) => {
    try {
      await createSiteSurveyResponse.mutateAsync(data);
      navigate('/admin/sitesurveyresponses');
    } catch (error) {
      console.error('Error creating SiteSurveyResponse:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/sitesurveyresponses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.SiteSurveyResponse.Edit'
    >
      <SiteSurveyResponseForm
        initialValues={{} as SiteSurveyResponseDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/sitesurveyresponses')}
      />
    </AdminLayout>
  );
};

export default SiteSurveyResponseCreate;
